import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import { useExpandedFdocContentContext } from './ExpandedFdocContentContext.js';
import { useResourceImageDataSafe } from '../context/resourceDataContext.js';
import { ButtonIconDownload } from '@fabric-app/ui/components/button/ButtonIconDownload';
import { styled } from 'styled-components';
import { PinchZoomImageV2 } from '@fabric-app/ui/components/images/PinchZoomImageV2';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { PinchZoomImage } from '@fabric-app/ui/components/images/PinchZoomImage';
import { isTouchScreen } from '@fabric-app/ui/utils/isTouchScreen';

function MediaContent({ imageRef, disableGestures }) {
  const { topHeaderControlsRef } = useExpandedFdocContentContext();
  const { resource, handleDownload } = useResourceImageDataSafe();
  const { isMobileView } = useResponsive();
  const downloadButton = topHeaderControlsRef && !!handleDownload ? /* @__PURE__ */ createPortal(/* @__PURE__ */ jsx(ButtonIconDownload, {
    onClick: handleDownload
  }), topHeaderControlsRef) : null;
  const imgSrc = resource.thumbnail?.lg || resource.data.webpage?.image?.url || resource.originUrl;
  const dimensions = resource.data.attributes?.dimensions;
  const dimensionStyles = dimensions?.height && dimensions.width ? {
    "--image-aspectRatio": `${dimensions.width} / ${dimensions.height}`,
    "--image-width": dimensions.height,
    "--image-height": dimensions.width,
    maxHeight: "100%"
  } : {};
  return imgSrc ? /* @__PURE__ */ jsxs(Fragment, {
    children: [
      downloadButton,
      /* @__PURE__ */ jsx(Container, {
        style: dimensionStyles,
        "data-pan-id-ignore-expanded-resource": "xy",
        children: isMobileView && isTouchScreen() ? /* @__PURE__ */ jsx(PinchZoomImageV2, {
          height: dimensions?.height || resource.data.webpage?.image?.height || 0,
          width: dimensions?.width || resource.data.webpage?.image?.width || 0,
          srcs: {
            default: imgSrc,
            zoomed: resource.thumbnail?.original || resource.originUrl
          }
        }) : /* @__PURE__ */ jsx(PinchZoomImage, {
          src: imgSrc,
          alt: resource.name || "",
          ref: imageRef,
          disableGestures,
          srcHq: resource.thumbnail?.original || resource.originUrl
        })
      })
    ]
  }) : null;
}
const Container = styled.div.withConfig({
  displayName: "MediaContent__Container",
  componentId: "sc-9d09a9b2-0"
})([
  `height:100%;`
]);

export { MediaContent };
//# sourceMappingURL=MediaContent.js.map
